require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2008-11-13-embed-joost.json") })
        }
      }, "path---articles-2008-11-13-embed-joost");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2008-11-13-embed-joost!./.cache/json/articles-2008-11-13-embed-joost.json
// module id = 555
// module chunks = 231608221292675